import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#068CF9",
      d: "M10 2.5a4.167 4.167 0 0 1 4.167 4.167V7.5a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5H5.834a2.5 2.5 0 0 1-2.5-2.5v-5a2.5 2.5 0 0 1 2.5-2.5v-.833A4.167 4.167 0 0 1 10.001 2.5m0 8.333a.833.833 0 0 0-.833.834v1.666a.833.833 0 1 0 1.667 0v-1.666a.833.833 0 0 0-.833-.834m0-6.666a2.5 2.5 0 0 0-2.5 2.5V7.5h5v-.833a2.5 2.5 0 0 0-2.5-2.5"
    }, null, -1)
  ])))
}
export default { render: render }